import { Dropdown, InputItem } from "pepsico-ds";
import Table from "../../../components/common/table/Table";
import { FeatureToggle, useFeatureToggle } from "../../../utils/featureToggle";
import { HEADER_DATA, MESSAGES, STYLES, TABLE_CONFIG } from "./constants";
import "./keywordManagement.scss";
import { transformKeywordsToRowData } from "./utils";

const KeywordsTable = ({
  keywords,
  categories,
  loading,
  searchTerm,
  searchCategories,
  handleEdit,
  handleSoftDelete,
  handleSearchChange,
  handleSearchCategory,
}) => {
  const showKeywordCategory = useFeatureToggle(FeatureToggle.showKeywordCategory);

  const headerData = showKeywordCategory
    ? HEADER_DATA
    : HEADER_DATA.filter((col) => col.columnKey !== "category");

  const rowData = transformKeywordsToRowData(
    keywords,
    handleEdit,
    handleSoftDelete,
    showKeywordCategory
  );

  if (loading) {
    return <div style={STYLES.loadingContainer}>{MESSAGES.LOADING}</div>;
  }

  return (
    <div className="keywords-table-container">
      <div className="keywords-table-header">
        <div className="keywords-table-search">
          <InputItem
            placeholder={TABLE_CONFIG.SEARCH_PLACEHOLDER}
            trailingIcon="search"
            size="medium"
            className="input-search"
            onChange={handleSearchChange}
            value={searchTerm}
          />
        </div>
        {showKeywordCategory && (
          <div className="filter-wrapper">
            <Dropdown
              childList={categories}
              selection="multiple"
              selectedValue={searchCategories}
              placeholder="Category"
              size="medium"
              className="filter-dropdown"
              setSelectedValue={handleSearchCategory}
            />
          </div>
        )}
      </div>
      <Table
        headerData={headerData}
        rowData={rowData}
        className="keywords-table"
        pagination={true}
        rowsPerPage={TABLE_CONFIG.ROWS_PER_PAGE}
        noDataLabel={TABLE_CONFIG.NO_DATA_LABEL}
      />
    </div>
  );
};

export default KeywordsTable;
